import { useEffect, type ReactNode } from 'react';
import '@/styles/aimup-redesign-performance.css';

/**
 * Dialog im Fokusmodus nach Vorlage performanceTest_testphase*_dialogInfo / _dialogTestAbbrechen:
 * Titel, Text, Knöpfe rechtsbündig. Klick daneben und Escape schließen.
 * `width`: Breite des Dialogs (Standard 420 px; Vorlagen Persönliches Training 440/460 px).
 */
export default function PerformanceTestDialog({
  title,
  children,
  actions,
  onClose,
  width,
}: {
  title: string;
  children: ReactNode;
  actions: ReactNode;
  onClose: () => void;
  width?: number;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') { e.preventDefault(); onClose(); } };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="aur-pt-dlg-backdrop" role="presentation" style={width ? { gridTemplateColumns: `minmax(0,${width}px)` } : undefined} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <section className="aur-pt-dlg" role="dialog" aria-modal="true" aria-label={title}>
        <h3>{title}</h3>
        <div className="aur-pt-dlg-text">{children}</div>
        <div className="aur-pt-dlg-actions">{actions}</div>
      </section>
    </div>
  );
}
